import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatMoneyWithSeparators } from '@/utils';
import { StyledWrapper, StyledRow, StyledText, StyledNumber } from './StockBalancesSummaryStyles';

type TProps = {
  totalSum?: number;
  isLoaded?: boolean;
};

const StockBalancesSummary = ({ totalSum, isLoaded }: TProps) => {
  const { t } = useTranslation(['stockBalances']);

  if (!isLoaded) {
    return null;
  }

  return (
    <StyledWrapper>
      <StyledRow>
        <StyledText>{t('summary_total_value')}:</StyledText>
        <StyledNumber>{formatMoneyWithSeparators(totalSum)} ₴</StyledNumber>
      </StyledRow>
    </StyledWrapper>
  );
};

export default StockBalancesSummary;
